var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "services icon / gas copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D-messaging-4.1-payments-B-sent",
    transform: "translate(-82.000000, -251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "services-icon-/-open",
    transform: "translate(31.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,4 C11.1633702,4 4,11.163473 4,20.0002297 C4,23.724813 5.2764174,27.1494639 7.41082245,29.8686073 L5.45508827,35.8603683 L11.8555476,33.7714048 C14.2416535,35.1856349 17.0246017,36 20,36 C28.8361705,36 36,28.836527 36,20.0002297 C36,11.163473 28.8361705,4 20,4 Z",
    id: "Stroke-1",
    stroke: "#32122F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#32122F",
    fillRule: "evenodd",
    cx: 20,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#32122F",
    fillRule: "evenodd",
    cx: 12,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#32122F",
    fillRule: "evenodd",
    cx: 28,
    cy: 20,
    r: 2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzRweCIgaGVpZ2h0PSIzNHB4IiB2aWV3Qm94PSIwIDAgMzQgMzQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjUgKDY3NDY5KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5zZXJ2aWNlcyBpY29uIC8gZ2FzIGNvcHkgMzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJELW1lc3NhZ2luZy00LjEtcGF5bWVudHMtQi1zZW50IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODIuMDAwMDAwLCAtMjUxLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ4LjAwMDAwMCwgMjEyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9InNlcnZpY2VzLWljb24tLy1vcGVuIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMS4wMDAwMDAsIDM2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMCw0IEMxMS4xNjMzNzAyLDQgNCwxMS4xNjM0NzMgNCwyMC4wMDAyMjk3IEM0LDIzLjcyNDgxMyA1LjI3NjQxNzQsMjcuMTQ5NDYzOSA3LjQxMDgyMjQ1LDI5Ljg2ODYwNzMgTDUuNDU1MDg4MjcsMzUuODYwMzY4MyBMMTEuODU1NTQ3NiwzMy43NzE0MDQ4IEMxNC4yNDE2NTM1LDM1LjE4NTYzNDkgMTcuMDI0NjAxNywzNiAyMCwzNiBDMjguODM2MTcwNSwzNiAzNiwyOC44MzY1MjcgMzYsMjAuMDAwMjI5NyBDMzYsMTEuMTYzNDczIDI4LjgzNjE3MDUsNCAyMCw0IFoiIGlkPSJTdHJva2UtMSIgc3Ryb2tlPSIjMzIxMjJGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGw9IiMzMjEyMkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY3g9IjIwIiBjeT0iMjAiIHI9IjIiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwtQ29weSIgZmlsbD0iIzMyMTIyRiIgZmlsbC1ydWxlPSJldmVub2RkIiBjeD0iMTIiIGN5PSIyMCIgcj0iMiI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC1Db3B5LTIiIGZpbGw9IiMzMjEyMkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY3g9IjI4IiBjeT0iMjAiIHI9IjIiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { ForwardRef as ReactComponent };